
import { Box, Button } from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CircleCheckIcon, Refresh01Icon} from "@hugeicons/core-free-icons";

export const ToggleResolvedButton = ({ conversation, toggleResolved }) => {
  const isResolved = !!conversation.resolved;

  return (
    <Box>
      <Button
        color={!isResolved ? "success" : "error"}
        variant={"ghost"}
        size="small"
        onClick={toggleResolved}
        sx={{
          px: 2,
          borderRadius: 3,
          textTransform: "none",
        }}
        startIcon={isResolved ? <HugeiconsIcon icon={Refresh01Icon} size={16} /> : <HugeiconsIcon icon={CircleCheckIcon} size={16} />}
      >
        {isResolved ? "Mark as Unresolved" : "Mark as Resolved"}
      </Button>
    </Box>
  );
}
